module.exports = __webpack_public_path__ + "static/media/DatabaseApp.e18fb27b.gif";